import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import css from "./SufferingAxis.module.css";
import { Head } from "../../Utils/Head";
import { Input } from "../Forms/Input";
import { ClinicContext } from "../../Context/ClinicContext";
import { UserContext } from "../../Context/UserContext";
import { updateUserFirebase } from "../../Utils/firebaseUser";
import {
  anxietyThoughtsPt,
  depressionThoughtsPt,
} from "../../Utils/thoughtsLists";

export const SufferingAxis = () => {
  const {
    answer1,
    setAnswer1,
    answer2,
    setAnswer2,
    answer3,
    setAnswer3,
    answer4,
    setAnswer4,
    answer5,
    setAnswer5,
    answer6,
    setAnswer6,
  } = useContext(ClinicContext);
  const { userData, setUserData } = useContext(UserContext);
  const { step, setStep } = useContext(ClinicContext);
  const navigate = useNavigate();

  const handleThoughtsList = () => {
    if (
      answer2 &&
      answer1 === "dep" &&
      depressionThoughtsPt.indexOf(answer2[3]) + 4 < depressionThoughtsPt.length
    ) {
      const index = depressionThoughtsPt.indexOf(answer2[3]);
      index > depressionThoughtsPt.length
        ? setAnswer2([...depressionThoughtsPt.slice(0, 4)])
        : setAnswer2([...depressionThoughtsPt.slice(index, index + 4)]);
    } else if (
      answer2 &&
      answer1 === "anx" &&
      anxietyThoughtsPt.indexOf(answer2[3]) + 4 < anxietyThoughtsPt.length
    ) {
      const index = anxietyThoughtsPt.indexOf(answer2[3]);
      index + 9 > anxietyThoughtsPt.length
        ? setAnswer2([...anxietyThoughtsPt.slice(0, 4)])
        : setAnswer2([...anxietyThoughtsPt.slice(index, index + 4)]);
    } else {
      answer1 === "dep" && setAnswer2(depressionThoughtsPt.slice(0, 4));
      answer1 === "anx" && setAnswer2(anxietyThoughtsPt.slice(0, 4));
    }
    console.log(answer3);
  };

  const finish = () => {
    const updatedJourney = {
      level: 1,
      lesson: 1,
    };

    userData.journey = updatedJourney;
    setUserData(userData);
    updateUserFirebase(userData);
    setStep(0);
    navigate("/");
  };

  return (
    <div className={css.container}>
      <Head title="SufferingAxis" description={"SufferingAxis - Mairini"} />
      <section className={css.gridTop}>
        <i
          className={`material-icons ${css.topbarIcon}`}
          onClick={() => {
            setStep(0);
            navigate("/");
          }}
        >
          close
        </i>
        <div className={css.traitBar}>
          <div
            className={css.traitScore}
            style={{
              marginRight: `${((9 - step) * 100) / 9}%`,
            }}
          ></div>
        </div>
      </section>
      <section className={css.gridMain}>
        {step === 0 && (
          <>
            <h1>Alguns pensamentos parecem grudar na nossa mente.</h1>
            <h1>Eles voltam sempre… e muitas vezes nos fazem sofrer.</h1>
            <h1>
              Vamos investigar juntos quais têm te afetado mais ultimamente.
            </h1>
          </>
        )}
        {step === 1 && (
          <>
            <h1>
              Alguns pensamentos nos prendem em ciclos difíceis. Qual destes
              aparece mais no seu dia a dia?
            </h1>
            <h1>🔸 Depressão (culpa, desânimo, falta de sentido)</h1>
            <h1>🔹 Ansiedade (medos, preocupações, tensão)</h1>
            <div className={css.cardContainer}>
              <div
                className={answer1 === "dep" ? css.cardActive : css.card}
                onClick={() => setAnswer1("dep")}
              >
                Depressão
              </div>
              <div
                className={answer1 === "anx" ? css.cardActive : css.card}
                onClick={() => setAnswer1("anx")}
              >
                Ansiedade
              </div>
            </div>
          </>
        )}
        {step === 2 && (
          <>
            {/* <div className={css.cardContainer}> */}
            {answer3 &&
              answer3.map((c, i) => (
                <div className={css.card} key={i}>
                  🧠 {c}{" "}
                </div>
              ))}
            {/* </div> */}
            <p>
              Marque até
              <span> três pensamentos </span>
              abaixo que mais se parecem com os seus.
            </p>
            {/* <h1>
              Eles não te definem — mas ajudam a entender o que tem doído.
            </h1> */}
            {answer1 === "anx"
              ? anxietyThoughtsPt.map((t) => (
                  <div key={t} className={css.cardContainer}>
                    <div
                      className={
                        answer3.indexOf(t) >= 0 ? css.cardActive : css.card
                      }
                      onClick={() =>
                        answer3.indexOf(t) >= 0
                          ? setAnswer3(answer3.filter((a) => a !== t))
                          : answer3.length < 3 && setAnswer3([...answer3, t])
                      }
                    >
                      {t}
                    </div>
                  </div>
                ))
              : depressionThoughtsPt.map((t) => (
                  <div key={t} className={css.cardContainer}>
                    <div
                      className={
                        answer3.indexOf(t) >= 0 ? css.cardActive : css.card
                      }
                      onClick={() =>
                        answer3.indexOf(t) >= 0
                          ? setAnswer3(answer3.filter((a) => a !== t))
                          : answer3.length < 3 && setAnswer3([...answer3, t])
                      }
                    >
                      {t}
                    </div>
                  </div>
                ))}
            {/* <div className={css.cardContainer}>
              <div
                className={css.cardMore}
                onClick={() => {
                  handleThoughtsList();
                  setPage(page + 1);
                }}
              >
                Ver Outros
              </div>
            </div> */}
          </>
        )}
        {step === 3 && (
          <>
            <h1>Cada pensamento costuma puxar você para algum lugar:</h1>
            <h1>🔸 O passado (erros, perdas, lembranças)</h1>
            <h1>🔹 O futuro (medos, expectativas, “e se?”)</h1>
            <h1>
              Para cada pensamento, selecione para onde ele tenta te levar
            </h1>

            <div className={css.cardSample}>🧠 {answer3[0]}</div>
            <div className={css.cardContainer}>
              <div
                className={answer4 === "past" ? css.cardActive : css.card}
                onClick={() => setAnswer4("past")}
              >
                Passado
              </div>
              <div
                className={answer4 === "future" ? css.cardActive : css.card}
                onClick={() => setAnswer4("future")}
              >
                Futuro
              </div>
            </div>
            <div className={css.cardSample}>🧠 {answer3[1]}</div>
            <div className={css.cardContainer}>
              <div
                className={answer5 === "past" ? css.cardActive : css.card}
                onClick={() => setAnswer5("past")}
              >
                Passado
              </div>
              <div
                className={answer5 === "future" ? css.cardActive : css.card}
                onClick={() => setAnswer5("future")}
              >
                Futuro
              </div>
            </div>
            <div className={css.cardSample}>🧠 {answer3[2]}</div>
            <div className={css.cardContainer}>
              <div
                className={answer6 === "past" ? css.cardActive : css.card}
                onClick={() => setAnswer6("past")}
              >
                Passado
              </div>
              <div
                className={answer6 === "future" ? css.cardActive : css.card}
                onClick={() => setAnswer6("future")}
              >
                Futuro
              </div>
            </div>
          </>
        )}
        {step === 4 && (
          <>
            <p>
              Às vezes, ficamos presos entre dores do passado e ansiedades sobre
              o futuro.
            </p>
            <p>Isso alimenta emoções difíceis: tristeza, medo, culpa, raiva.</p>
            <p>
              E nos afasta do único tempo onde podemos agir:{" "}
              <span>o agora.</span>
            </p>
            <div className={css.grid3}>
              <div>
                <div className={css.cardSample}>{answer3[0]}</div>
                <div className={css.cardSample}>{answer3[1]}</div>
                <div className={css.cardSample}>{answer3[2]}</div>
              </div>
              <div>
                <i className={`material-icons ${css.topbarIcon}`}>sync_alt</i>
              </div>
              <div>
                <div className={css.cardSample}>
                  {answer4 === "future" ? "Futuro" : "Passado"}
                </div>
                <div className={css.cardSample}>
                  {answer5 === "future" ? "Futuro" : "Passado"}
                </div>
                <div className={css.cardSample}>
                  {answer6 === "future" ? "Futuro" : "Passado"}
                </div>
              </div>
            </div>
          </>
        )}
        {step === 5 && (
          <>
            <h1>
              O presente é o único momento em que algo pode, de fato, ser feito.
            </h1>
            <h1>Nele, existe espaço para escolher, mudar, recomeçar.</h1>
            <h1>
              A chave está em trazer a atenção de volta para aqui e agora.
            </h1>
          </>
        )}
        {step === 6 && (
          <>
            <h1>Sua mente pode viajar. Mas o corpo está sempre presente.</h1>
            <h1>Tocar, ver, ouvir, cheirar, saborear…</h1>
            <h1>
              Essas sensações dizem à sua mente: “você está seguro agora”.
            </h1>
          </>
        )}
        {step === 7 && (
          <>
            <h1>
              Abaixo estão algumas opções que você poderá fazer para manter a
              atenção no presente.
            </h1>
            <p>
              <span>🖐️ Tato: </span>segure uma pedra de gelo e perceba o toque.
            </p>
            <p>
              <span>👁️ Visão: </span>observe 3 objetos à sua volta e descreva.
            </p>
            <p>
              <span>👂 Audição: </span>note todos os sons do ambiente.
            </p>
            <p>
              <span>👅 Paladar: </span>coma algo devagar, notando cada sabor.
            </p>
            <p>
              <span>👃 Olfato: </span>sinta o cheiro de uma flor, planta ou
              tempero.
            </p>
          </>
        )}
        {step === 8 && (
          <>
            <h1>
              Se sua mente viajar, não tente controlá-la ou brigar com ela.
            </h1>
            <h1>
              Apenas volte aos seus sentidos, ao agora, ao que é possível.
            </h1>
            <h1>Você está no tempo certo para mudar.</h1>
            <h1>E já deu o primeiro passo.</h1>
          </>
        )}
        {step === 9 && (
          <>
            <h1>Parabéns! Você terminou essa lição.</h1>
            <h1>
              Clique abaixo para práticas relacionados com o que aprendeu.
            </h1>
            <h1>
              <a href={"https://mairini.com/practices"} target="_blank">
                Ir para as Práticas
              </a>
            </h1>
          </>
        )}
      </section>
      <div>
        <hr />

        <section className={css.gridOptions}>
          {step > 0 ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step - 1);
              }}
            >
              Anterior
            </button>
          ) : (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Anterior
            </button>
          )}
          {step === 1 && !answer1 ? (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Próximo
            </button>
          ) : step === 2 && !answer3[2] ? (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Próximo
            </button>
          ) : (step === 3 && !answer4) ||
            (step === 3 && !answer5) ||
            (step === 3 && !answer6) ? (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Próximo
            </button>
          ) : step === 9 ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                finish();
              }}
            >
              Finalizar
            </button>
          ) : (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                handleThoughtsList();
                setStep(step + 1);
              }}
            >
              Próximo
            </button>
          )}
        </section>
      </div>
    </div>
  );
};
